/**
 *  Date formats
 */
export const YEAR_MONTH_DAY_DASH_FORMAT = 'yyyy-MM-dd' //ex: 2021-08-02
export const MONTH_DAY_YEAR_SLASH_FORMAT = 'MM/dd/yyyy' //ex: 08/02/2021
export const DAY_MONTH_YEAR_SLASH_FORMAT = 'dd/MM/yyyy' //ex: 02/08/2021
export const MONTH_DAY_SHORT_YEAR_SLASH_FORMAT = 'MM/dd/yy' //ex: 08/02/21
export const PRETTY_DAY_MONTH_NUM_DAY_FORMAT = 'ccc, MMM d' //ex: Thu, Aug 2
export const PRETTY_MONTH_DAY_YEAR_FORMAT = 'MMM d, yyyy' //ex: Aug 2, 2021
export const HOURS_CAP_AM_PM_FORMAT = 'h:mm a' //ex: 3:33 PM
export const PRETTY_MONTH_NUM_DAY_YEAR_FORMAT = 'MMM dd, yyyy' //ex: Aug 02, 2021
export const PRETTY_MONTH_NUM_DAY_FORMAT = 'MMM dd' //ex: Aug 12
export const NUM_DAY_PRETTY_MONTH_FORMAT = 'd MMM' //ex: 2 Aug
export const DOUBLE_NUM_DAY_PRETTY_MONTH_FORMAT = 'dd MMM' //ex: 02 Aug
export const TIME_AM_PM_FORMAT = 'hh:mm aaa' //03:33 pm
export const TIME_CAP_AM_PM_FORMAT = 'hh:mm a' //03:33 PM
export const PRETTY_MONTH_DAY_TIMESTAMP_FORMAT = 'MMMM do @ h:mm a' //ex: August 12th @ 8:30 PM
export const FULL_MONTH_NAME_FORMAT = 'MMMM' //ex: August
export const PRETTY_DAY_NUM_FORMAT = 'EEE d' //ex: Mon 2
export const MONTH_DAY_SLASH_FORMAT = 'MM/dd' //ex: 08/12
export const MONTH_DAY_SHORT_FORMAT = 'MMM d' //ex: Aug 12
export const DAY_MONTH_SHORT_FORMAT = 'd MMM' //ex: 12 Aug
export const PRETTY_DAY_MONTH_NUM_DAY_YEAR_FORMAT = 'ccc, MMMM d, yyyy' //ex: Thu, August 12, 2021
export const PRETTY_FULLDAY_MONTH_NUM_DAY_FORMAT = 'cccc, MMMM d' // Thursday, August 24
